import { t } from '../i18n/nl.js';

const STATUS_MAP = {
  draft:           { key: 'status.draft',           cls: 'badge-draft' },
  sent:            { key: 'status.sent',            cls: 'badge-sent' },
  paid:            { key: 'status.paid',            cls: 'badge-paid' },
  reminded:        { key: 'status.reminded',        cls: 'badge-reminded' },
  final_notice:    { key: 'status.final_notice',    cls: 'badge-final-notice' },
  collections:     { key: 'status.collections',     cls: 'badge-collections' },
  partially_paid:  { key: 'status.partially_paid',  cls: 'badge-partially-paid' },
};

export default function StatusBadge({ status }) {
  const entry = STATUS_MAP[status];
  const label = entry ? t(entry.key) : status;
  const cls = entry?.cls ?? 'badge-draft';
  return <span className={`badge ${cls}`}>{label}</span>;
}
